module.exports = __webpack_public_path__ + "c563ac03accfe05666530033b7a2ccf0.svg";